const Pdata=[
{
    link :require("../images/1.jpg"),
    pname: "Covid19",
    url:"https://covid19-statewise-reactapp.netlify.app/"
},

{
    link:require("../images/2.jpg"),
    pname: "my netflix App",
    url:"https://my-netflix-reactapp.netlify.app/"
},

{
    link:require("../images/3.jpg"),
    pname: "Accordium app",
    url:"https://accordium-reactapp.netlify.app/"
}
]
export default Pdata